import { render, staticRenderFns } from "./center-container.vue?vue&type=template&id=896ab43a&scoped=true&"
import script from "./center-container.vue?vue&type=script&lang=js&"
export * from "./center-container.vue?vue&type=script&lang=js&"
import style0 from "./center-container.vue?vue&type=style&index=0&id=896ab43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ab43a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('896ab43a', component.options)
    } else {
      api.reload('896ab43a', component.options)
    }
    module.hot.accept("./center-container.vue?vue&type=template&id=896ab43a&scoped=true&", function () {
      api.rerender('896ab43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lib/center-container.vue"
export default component.exports